import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HomeIcon from '@mui/icons-material/Home';
import { Box, Typography, Container, Button, Paper } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import Taskbar from '../dashboard/components/Taskbar.component';
import { theme } from '../../theme';

const PageContainer = styled.div`
  min-height: 100vh;
  background-color: #061308;
  color: white;
  padding-bottom: 60px;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  padding: 25px 40px;
  margin-bottom: 30px;
  border-bottom: 1px solid rgba(31, 207, 94, 0.4);
  background-color: rgba(0, 20, 10, 0.6);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
`;

const Title = styled.h2`
  color: white;
  margin: 0;
  font-size: 28px;
  display: flex;
  align-items: center;
  font-weight: normal;

  svg {
    margin-right: 12px;
    color: ${theme.colors.green};
  }
`;

const BackButton = styled.button`
  background: none;
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 8px 15px;
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-right: 25px;
  transition: all 0.2s ease;
  border-radius: 4px;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.5);
  }

  svg {
    margin-right: 5px;
  }
`;

const ContentWrapper = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 0 20px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ErrorIcon = styled(ErrorOutlineIcon)`
  font-size: 80px !important;
  color: rgba(31, 207, 94, 0.8);
  margin-bottom: 24px;
`;

const StyledButton = styled(Button)`
  &.MuiButton-contained {
    background-color: rgba(31, 207, 94, 0.7) !important;
    color: white !important;
    border-radius: 4px !important;
    font-weight: normal !important;
    text-transform: none !important;
    padding: 10px 20px;
    margin: 0 8px;

    &:hover {
      background-color: rgba(31, 207, 94, 0.9) !important;
    }

    .MuiSvgIcon-root {
      margin-right: 8px;
    }
  }
`;

const ErrorCode = styled(Typography)`
  font-size: 120px !important;
  font-weight: 700 !important;
  color: rgba(31, 207, 94, 0.2) !important;
  position: absolute;
  z-index: 0;
  transform: translateY(-50%);
`;

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1);
  };

  const handleHomeClick = () => {
    navigate('/');
  };

  return (
    <PageContainer>
      <Header>
        <BackButton onClick={handleBackClick}>
          <ArrowBackIcon />
          Tilbake
        </BackButton>
        <Title>
          <ErrorOutlineIcon />
          Side ikke funnet
        </Title>
      </Header>

      <ContentWrapper>
        <Container maxWidth="md">
          <Paper
            sx={{
              p: 5,
              backgroundColor: 'rgba(0, 0, 0, 0.6) !important',
              border: '1px solid rgba(31, 207, 94, 0.2)',
              position: 'relative',
              overflow: 'hidden',
              zIndex: 1,
              textAlign: 'center',
            }}
          >
            <ErrorCode variant="h1">404</ErrorCode>
            <Box sx={{ position: 'relative', zIndex: 2 }}>
              <ErrorIcon />
              <Typography variant="h4" sx={{ color: 'white', mb: 2 }}>
                Ups! Denne siden finnes ikke
              </Typography>
              <Typography
                variant="body1"
                sx={{ color: 'rgba(255, 255, 255, 0.8)', mb: 4, maxWidth: '500px', mx: 'auto' }}
              >
                Siden du leter etter er blitt flyttet, fjernet eller finnes ikke. Det kan også hende
                at du har skrevet inn feil adresse.
              </Typography>

              <Box sx={{ mt: 4 }}>
                <StyledButton
                  variant="contained"
                  onClick={handleBackClick}
                  startIcon={<ArrowBackIosNewIcon />}
                >
                  Gå tilbake
                </StyledButton>
                <StyledButton
                  variant="contained"
                  onClick={handleHomeClick}
                  startIcon={<HomeIcon />}
                >
                  Gå til forsiden
                </StyledButton>
              </Box>
            </Box>
          </Paper>
        </Container>
      </ContentWrapper>

      <Taskbar />
    </PageContainer>
  );
};

export default NotFound;
